/* Spytec GPS partnerships page (sections/partners-landing.liquid).
   - Path-card buttons preselect "Partnership interest" and jump to the form.
   - Inline required-field validation.
   - Submits to the Hapn HubSpot partner form via the Forms API v3.
     The HubSpot form only defines firstname, lastname, email, phone and
     country__dropdown_, so company + partnership interest + notes + the
     consent record go in the standard `company` and `message` contact
     properties. If HubSpot rejects those extra fields, it resubmits with
     the form's own fields and carries interest/company on pageUri. */
(function () {
  function init(root) {
    if (!root || root.dataset.ptnReady) return;
    root.dataset.ptnReady = '1';

    var form = root.querySelector('[data-ptn-form]');
    if (!form) return;
    var portal = form.dataset.portal;
    var formId = form.dataset.formId;
    var formError = root.querySelector('[data-ptn-form-error]');
    var success = root.querySelector('[data-ptn-success]');
    var interest = form.elements.partnership_type;
    var submit = form.querySelector('[type="submit"]');
    var submitLabel = submit ? submit.querySelector('[data-ptn-submit-label]') : null;
    var submitText = submitLabel ? submitLabel.textContent : '';

    // Path cards → preselect + jump to form
    root.querySelectorAll('[data-ptn-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (interest) {
          interest.value = btn.dataset.ptnSelect;
          clearError(interest);
        }
        var target = root.querySelector('#' + form.dataset.anchor);
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        window.setTimeout(function () {
          var first = form.elements.firstname;
          (first && !first.value ? first : interest || first).focus({ preventScroll: true });
        }, reduce ? 0 : 600);
      });
    });

    function errorEl(field) {
      return field.id ? root.querySelector('[data-ptn-error-for="' + field.id + '"]') : null;
    }
    function setError(field, message) {
      field.setAttribute('aria-invalid', 'true');
      var el = errorEl(field);
      if (el) { el.textContent = message; el.hidden = false; }
      if (field.type === 'checkbox') field.closest('.ptn__consent').classList.add('is-invalid');
    }
    function clearError(field) {
      field.removeAttribute('aria-invalid');
      var el = errorEl(field);
      if (el) { el.textContent = ''; el.hidden = true; }
      if (field.type === 'checkbox') field.closest('.ptn__consent').classList.remove('is-invalid');
    }
    function messageFor(field) {
      if (field.type === 'checkbox') return 'Please accept the privacy and communications terms.';
      if (field.type === 'email' && field.value.trim()) return 'Enter a valid work email address.';
      if (field.type === 'tel' && field.value.trim()) return 'Enter a valid phone number.';
      return 'This field is required.';
    }
    function isValid(field) {
      if (field.type === 'checkbox') return !field.required || field.checked;
      var v = field.value.trim();
      if (field.required && !v) return false;
      if (field.type === 'email' && v) return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      if (field.type === 'tel' && v) return v.replace(/\D/g, '').length >= 7;
      return true;
    }
    function check(field) {
      if (isValid(field)) { clearError(field); return true; }
      setError(field, messageFor(field));
      return false;
    }

    var fields = Array.prototype.slice.call(form.querySelectorAll('input, select, textarea')).filter(function (f) {
      return f.type !== 'hidden' && f.name;
    });
    fields.forEach(function (f) {
      var evt = (f.type === 'checkbox' || f.tagName === 'SELECT') ? 'change' : 'blur';
      f.addEventListener(evt, function () { if (f.getAttribute('aria-invalid') === 'true' || f.value) check(f); });
      f.addEventListener('input', function () { if (f.getAttribute('aria-invalid') === 'true') check(f); });
    });

    function val(name) { return form.elements[name] ? String(form.elements[name].value || '').trim() : ''; }
    function cookie(name) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }

    function post(fieldList, pageUri) {
      var context = { pageUri: pageUri, pageName: document.title };
      var hutk = cookie('hubspotutk');
      if (hutk) context.hutk = hutk;
      return fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + portal + '/' + formId, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ submittedAt: Date.now(), fields: fieldList, context: context })
      }).then(function (res) {
        if (res.ok) return res;
        var err = new Error('HubSpot ' + res.status);
        err.status = res.status;
        throw err;
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (formError) formError.textContent = '';

      var firstBad = null;
      fields.forEach(function (f) { if (!check(f) && !firstBad) firstBad = f; });
      if (firstBad) {
        if (formError) formError.textContent = 'Please complete the highlighted fields.';
        firstBad.focus();
        return;
      }

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      if (submitLabel) submitLabel.textContent = 'Sending…';

      var interestVal = val('partnership_type');
      var company = val('company');
      var notes = val('partnership_notes');
      var consentText = root.querySelector('[data-ptn-consent-text]');
      var message = [
        'Partnership interest: ' + interestVal,
        'Company: ' + company,
        notes ? 'Notes: ' + notes : '',
        'Consent: accepted "' + (consentText ? consentText.textContent.replace(/\s+/g, ' ').trim() : 'privacy and communications terms') + '" at ' + new Date().toISOString(),
        'Source: ' + (form.dataset.source || 'Spytec GPS partnerships page')
      ].filter(Boolean).join('\n');

      var base = ['firstname', 'lastname', 'email', 'phone', 'country__dropdown_'].map(function (name) {
        return { objectTypeId: '0-1', name: name, value: val(name) };
      });
      var enriched = base.concat([
        { objectTypeId: '0-1', name: 'company', value: company },
        { objectTypeId: '0-1', name: 'message', value: message }
      ]);

      var pageUri = window.location.origin + window.location.pathname;
      var fallbackUri = pageUri + '?partner_interest=' + encodeURIComponent(interestVal) + '&company=' + encodeURIComponent(company);

      post(enriched, pageUri)
        .catch(function (err) {
          // 400 = HubSpot refused a field; retry with only the form's own fields.
          if (err.status === 400) return post(base, fallbackUri);
          throw err;
        })
        .then(function () {
          if (window.dataLayer && typeof window.dataLayer.push === 'function') {
            window.dataLayer.push({ event: 'partner_inquiry_submitted', partnership_type: interestVal });
          }
          form.hidden = true;
          if (success) { success.hidden = false; success.focus(); }
        })
        .catch(function () {
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
          if (submitLabel) submitLabel.textContent = submitText;
          if (formError) formError.textContent = form.dataset.failMessage || 'We couldn’t submit the form just now. Please try again.';
        });
    });
  }

  function boot() { document.querySelectorAll('[data-ptn-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-ptn-root]')); });
})();
